// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pm-1";
export var stateContainer = "_pm-0";